import axios from 'axios'

import { mockIt } from './mock'

axios.defaults.withCredentials = true

// TODO: make it efficient
export const converxFunnelAPI = axios.create({
  baseURL: import.meta.env.DEV
    ? import.meta.env.VITE_COVERX_FUNNEL_API_URL_LOCAL
    : import.meta.env.VITE_COVERX_FUNNEL_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

export const realAxiosInstance = axios.create({
  baseURL: import.meta.env.DEV
    ? import.meta.env.VITE_COVERX_FUNNEL_API_URL_LOCAL
    : import.meta.env.VITE_COVERX_FUNNEL_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

export const coverxAPI = axios.create({
  baseURL: import.meta.env.VITE_COVERX_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

mockIt(converxFunnelAPI)

export default converxFunnelAPI
